import {
  Avatar,
  Box,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Typography,
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import LoadableImage from '../LoadableImage'
import { Damage } from '../../constants'

const DamagesList = ({
  damages,
  handleDamageListItemClick,
  damageTypes,
}: {
  damages: Damage[]
  handleDamageListItemClick: (damage: Damage) => void
  damageTypes: Record<string, string>
}) => {
  const { t } = useTranslation()

  return (
    <List sx={{ padding: 0 }}>
      {damages.map((damage) => {
        return (
          <Box key={damage.id}>
            <ListItem
              sx={(theme) => ({
                maxWidth: '100%',
                height: theme.spacing(8.875),
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2.5),
              })}
              onClick={() => {
                handleDamageListItemClick(damage)
              }}
            >
              <ListItemAvatar>
                <Avatar
                  sx={(theme) => ({
                    width: theme.spacing(7),
                    height: theme.spacing(7),
                    marginRight: theme.spacing(2),
                    '& img': {
                      objectFit: 'cover',
                      width: '100%',
                      height: '100%',
                    },
                  })}
                  variant="square"
                >
                  <LoadableImage
                    noLoading
                    blobId={
                      damage.photoUrlsThumbnails?.[0] || damage.photoUrls?.[0]
                    }
                    alt={t('alt.damage_item')}
                  />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={
                  Array.isArray(damage.classifications)
                    ? damage.classifications
                        .map((classification) => damageTypes[classification])
                        .join(', ')
                    : damageTypes[damage.classifications]
                }
                secondary={damage.description}
                sx={(theme) => ({
                  root: {
                    paddingRight: theme.spacing(4.5),
                  },
                  primary: {
                    lineHeight: '1.5rem',
                    width: 'calc(100% - 60px)',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                  },
                  secondary: {
                    whiteSpace: 'nowrap',
                    lineHeight: '1.25rem',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                  },
                })}
              />
              <ListItemSecondaryAction
                sx={{
                  top: '26px',
                  right: '32px',
                  '& p': {
                    fontWeight: 500,
                  },
                }}
              >
                <Typography variant="body2">
                  {new Date(damage.timestamp)
                    ?.toLocaleString('es-ES', {
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    })
                    ?.split('/')
                    .join('.')}
                </Typography>
              </ListItemSecondaryAction>
            </ListItem>
            <Divider
              sx={(theme) => ({
                backgroundColor: 'rgba(128,128,128,.12)',
                margin: theme.spacing(0, 2),
              })}
            />
          </Box>
        )
      })}
    </List>
  )
}

export default DamagesList
